/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 * - cart links: keep storefront navigation in the native drawer flow.
 */

let initialized = false;

function getCartDrawer() {
  return /** @type {HTMLElement & {open?: () => void} | null} */ (
    document.querySelector('theme-drawer#cart-drawer')
  );
}

/**
 * Opens the native cart drawer when it is available.
 * @returns {boolean}
 */
function openCartDrawer() {
  const drawer = getCartDrawer();
  if (!drawer?.open) return false;

  drawer.open();
  return true;
}

/**
 * Keeps storefront cart links in the native drawer flow. The cart page remains
 * available only as a no-JavaScript or missing-drawer fallback.
 * @param {MouseEvent} event
 */
function handleCartLinkClick(event) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }

  const source = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (!source || source.target === '_blank' || source.hasAttribute('download')) return;

  const destination = new URL(source.href, window.location.origin);
  const cartUrl = new URL(Theme.routes.cart_url || '/cart', window.location.origin);
  const normalizePath = (pathname) => pathname.replace(/\/+$/, '') || '/';

  if (destination.origin !== window.location.origin || normalizePath(destination.pathname) !== normalizePath(cartUrl.pathname)) {
    return;
  }

  if (!openCartDrawer()) return;
  event.preventDefault();
}

function init() {
  if (initialized) return;
  initialized = true;
  document.addEventListener('click', handleCartLinkClick);

  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      if (!openCartDrawer()) {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });

}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
